import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import starsImages from "../../assests/images/star.png";
import { onboardingServices } from "../../services/onboardingServices";
import { UserObj } from "../../services/localStarage";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { isEmptyDash } from "../../constant";
import _ from "lodash";
import ConfirmModal from "../common/confirmModal";
import DoneIcon from '@mui/icons-material/Done';
import Tooltip from '@mui/material/Tooltip';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Cheque",
  "Cash Payment",
  "NEFT Transfer",
  "RTGS Transfer",
  "Bank Transfer",
];

const validationResultArr1 = [
  { name: "GST", isValid: false },
  { name: "PAN", isValid: false },
  { name: "MSME", isValid: false },
];

function OnboardingProgress(props) {
  let navigate = useNavigate();
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
  const [progressStep, setProgressStep] = useState([]);
  const [validationResultArr, setValidationResultArr] =
    useState(validationResultArr1);
  const [textAreaVAl, setTextAreaVal] = useState("");
  const [submitParam, setSubmitParam] = useState("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalText, setConfirmModalText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isReinitiateDisabled, setIsReinitiateDisabled] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [isSapVendorCreation, setSapVendorCreation] = useState(false);
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (e, ele, i, fieldData, j) => {
    const {
      target: { value },
    } = e;
    let progressStepInit = _.cloneDeep(progressStep);
    progressStepInit.lastStepData.sections[i].fields[j].response.optionIds =
      e.target.value;
    setProgressStep(progressStepInit);
    // setPersonName(
    //   // On autofill we get a stringified value.
    //   typeof value === "string" ? value.split(",") : value
    // );
  };

  // const onSelectChange = (e, ele, i, fieldData, j) => {
  //   let progressStepInit = _.cloneDeep(progressStep); 
  //   progressStepInit.lastStepData.sections[i].fields[j].response.optionId = e.target.value;
  //   setProgressStep(progressStepInit);
  // };

  useEffect(() => {
    getFormProgress(props?.vendorId);
  }, []);

  const closeConfirmModal = () => {
    setConfirmModalText("");
    setIsConfirmModalOpen(false);
  };

  const successConfirmModal = () => {
    setIsLoading(true);
    handleSapCreateSubmit(submitParam);
  };

  // const getVendorDetails = (url) => {
  //   setIsLoading(true);
  //   vendorServices
  //     .getVendorDetails()
  //     .then(function (response) { 
  //       if (response?.data?.success == true) {
  //       }
  //     })
  //     .catch(function (error) { 
  //       openAlert(true, "error", `${error?.response?.data?.message}`);
  //     })
  //     .finally((param) => {
  //       setIsLoading(false);
  //     });
  // };

  const getFormProgress = (param) => {
    setIsLoading(true);
    onboardingServices
      .getFormProgress(param)
      .then(function (response) {
        setProgressStep(response.data.data);
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const [gstValidation, setGSTValidation] = useState("");
  const initiateProcess = (param) => {
    let obj = {
      vendorId: props?.vendorId,
      status: param,
    };
    setIsLoading(true);
    onboardingServices
      .initiateVerification(obj)
      .then(function (response) {
        if (response?.data?.success === true) {
          openAlert(true, "success", `${response?.data?.message}`);
          getFormProgress(props?.vendorId);
          setGSTValidation(response.data.data)
          window.location.reload();
        } else {
          setGSTValidation(response.data.data)
        }
        // setProgressStep(response.data.data); 
      })
      .catch(function (error) {
        if (error?.response?.data?.success === false) {
          setGSTValidation(error.response.data.data);
          // window.location.reload();
        }
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const viewDetails = () => {
    props.changeScreen(false);
  };

  const reInitateProcess = () => {
    setIsReinitiateDisabled(true);
    setIsSubmitButtonDisabled(false);
  }

  const discardReInitateProcess = () => {
    setIsReinitiateDisabled(false);
    setSapVendorCreation(false);
  }
  const onSelectChange = (e, ele, i, fieldData, j) => {
    let progressStepInit = _.cloneDeep(progressStep);
    progressStepInit.lastStepData.sections[i].fields[j].response.optionId =
      e.target.value;
    setProgressStep(progressStepInit);
  };

  const navigateUrl = (param) => {
    navigate(param);
  };

  const handleSapCreateSubmit = (param) => {
    let obj = {
      vendorId: props?.vendorId,
      remarks: textAreaVAl,
      status: param,
    };
    const button = document.querySelector('.sap_confirm');
    button.setAttribute('disabled', 'true');

    setIsLoading(true);
    onboardingServices
      .submitSAPCreation(obj)
      .then(function (response) {
        // getFormProgress(props?.vendorId);
        navigateUrl(`/admin/vendor-list`);
        openAlert(true, "success", `${response?.data?.message}`);
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        button.removeAttribute('disabled');
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const onSAPCreateClick = (param) => {
    setSubmitParam(param);
    let str = "";
    if (param == "Approved") {
      str = "This will initiate Vendor Creation in SAP. Do you want to Continue?"
    }
    if (param == "Rejected") {
      str = "This will reject vendor creation. Do you want to continue?"
    }
    setConfirmModalText(str);
    setIsConfirmModalOpen(true);
  };

  const onClearForm = (param) => {
    // getFormProgress(props?.vendorId);
    setIsLoading(true);
    window.location.reload();
  };

  const handleSubmit = () => {
    let progressStepInit = _.cloneDeep(progressStep);
    let isValid = true;
    let dataArr = [];

    let secLength = progressStepInit?.lastStepData?.sections.length;
    for (
      let i = 0;
      i <
      progressStepInit?.lastStepData?.sections[secLength - 1]?.fields.length;
      i++
    ) {
      if (
        progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
          .required == true &&
        progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
          .type == "Dropdown" &&
        isEmptyDash(
          progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
            ?.response?.optionId
        )
      ) {
        isValid = false;
      } else if (
        progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
          .required == true &&
        progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
          .type == "MultiSelect" &&
        isEmptyDash(
          progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
            ?.response?.optionIds.length
        )
      ) {
        isValid = false;
      } else {
        if (
          progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
            .type == "MultiSelect"
        ) {
          dataArr.push({
            questionId:
              progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
                ._id,
            optionIds:
              progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
                ?.response?.optionIds,
          });
        }

        if (
          progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
            .type == "Dropdown"
        ) {
          dataArr.push({
            questionId:
              progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
                ._id,
            optionId:
              progressStepInit?.lastStepData?.sections[secLength - 1]?.fields[i]
                ?.response?.optionId,
          });
        }
      }
    }

    if (isValid) {
      let obj = {
        vendorId: props?.vendorId,
        stepId: progressStep?.lastStepData?.stepId,
        formData: {
          sectionId:
            progressStepInit?.lastStepData?.sections[secLength - 1]?.sectionId,
          fields: [...dataArr],
        },
      };

      setIsLoading(true);
      onboardingServices
        .submitLastStepDetails(obj)
        .then(function (response) {
          getFormProgress(props?.vendorId);
          setSapVendorCreation(true); // SAP creation fail
          setIsSubmitButtonDisabled(true);// SAP creation fail
          openAlert(true, "success", `${response?.data?.message}`);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      openAlert(true, "error", `Please fill all required fields.`);
    }
  };

  let roleName = UserObj?.role.name;
  let userObjId = UserObj._id
  let referredById = progressStep.referredBy;
  return (
    <div className="onboard_progress-outer">
      <div>
        <Box className="lets_onboarding_status_react_bar">
          <Stepper activeStep={5} alternativeLabel>
            {progressStep?.progressDetails?.map((label, index) => (
              <Step key={label?.progressName}>
                <div className="text-center">
                  {label.uniqueName !== "thirdParty" ? (
                    <>
                      {label?.rating ? label?.rating : 0}/5{" "}
                      <img src={starsImages} alt="" />
                    </>
                  ) : (
                    <div className="spa" style={{ height: "23px" }}></div>
                  )}
                </div>
                <StepLabel className="lets_onboarding_status_welcome_listings">
                  {label?.progressName}
                </StepLabel>

                <div
                  className="completed_txt"
                  style={{
                    color: label?.status === "Pending" ? "#FC8B07" : "#4F9433",
                  }}
                >
                  {label?.status}
                </div>
                {label?.feedback ? (
                  <div className="received_box">
                    <h5 className="vendor_list_feedback_onboarding">
                      Comment received
                    </h5>
                    <h5>{label?.feedback}</h5>
                  </div>
                ) : (
                  <div className="received_box2"></div>
                )}

                {label.uniqueName == "thirdParty" &&
                  (label.status === "Approved" || label.status === "Skipped") && (
                    <div>
                     {(!isEmptyDash(progressStep?.validationResult)) &&  <div className="received_box">
                        <h5 className="vendor_list_feedback_onboarding">
                          Validation Result
                        </h5>

                        {(!isEmptyDash(progressStep?.validationResult?.GSTIN?.status)) && <div className="check_box_react_gst_progress_block" >
                            <p> GSTIN: </p>                            
                            <span>{progressStep?.validationResult?.GSTIN?.status}</span>
                        </div>}

                        {/* <div className="check_box_react_gst_progress_block" >
                            <p> MSME </p>      
                        </div> */}
                        {(!isEmptyDash(progressStep?.validationResult?.MSME_NO?.status)) && <div className="check_box_react_gst_progress_block" >
                            <p> MSME Status: </p>                            
                            <span>{progressStep?.validationResult?.MSME_NO?.status}</span>
                        </div>}
                        {(!isEmptyDash(progressStep?.validationResult?.MSME_NO?.enterpriseType)) && <div className="check_box_react_gst_progress_block" >
                            <p> Type of Enterprise: </p>                            
                            <span>{progressStep?.validationResult?.MSME_NO?.enterpriseType}</span>
                        </div>}

                        {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.status)) && <div className="check_box_react_gst_progress_block" >
                            <p> PAN Status: </p>                            
                            <span>{progressStep?.validationResult?.PAN_NO?.status}</span>
                        </div>}

                        {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.operativeStatus)) && <div className="check_box_react_gst_progress_block" >
                            <p> Operative Status: </p>                            
                            <span>{progressStep?.validationResult?.PAN_NO?.operativeStatus}</span>
                        </div>}

                        {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.specifiedPerson)) && <div className="check_box_react_gst_progress_block" >
                            <p> Specified Person: </p>                            
                            <span>{progressStep?.validationResult?.PAN_NO?.specifiedPerson}</span>
                        </div>}


                        {/* {Object.entries(progressStep?.validationResult).map(([key, value], i) => (
                          <div className="check_box_react_gst_progress_block" key={i}>
                            <p> {key === "PAN_NO" ? "PAN NO" : key === "MSME_NO" ? "MSME NO" : key}</p>
                            {value ? (
                              <DoneIcon className="icon_react_check_body" />
                            ) : (
                              <HighlightOffIcon className="icon_react_check_body" />
                            )}
                          </div>
                        ))} */}
                      </div>}

                    </div>
                  )}
                {label.uniqueName == "thirdParty" && progressStep?.onThirdParty === true &&
                  label.status != "Approved" &&
                  label.status != "Skipped" && (
                    <div>
                      {(userObjId == referredById) && (
                        <div className="btn_hold_initiate_react_onboarding_progress">
                          {/* {progressStep.isInitiationRequired === true && ( */}
                          <button
                            className="btn_initiate_react button-approve"
                            onClick={() => initiateProcess("Approved")}
                          >
                            Initiate{" "}
                          </button>

                          {/* // )}
                        // {progressStep.isInitiationRequired === false && (
                        //   <> */}
                          {label.status != "Hold" && (
                            <button
                              className="btn_hold_react button-hold"
                              onClick={() => initiateProcess("Hold")}
                            >
                              Hold
                            </button>
                          )}

                          <button
                            className="btn_hold_react button-reject"
                            onClick={() => initiateProcess("Skip")}
                          >
                            Skip
                          </button>
                          {/* </>
                        )} */}
                        </div>
                      )}
                      <>
                        { Object.keys(progressStep?.validationResult).length !== 0 && (
                          <div className="received_box">
                            <h5 className="vendor_list_feedback_onboarding">
                              Validation Result
                            </h5>
                                  
                              {(!isEmptyDash(progressStep?.validationResult?.GSTIN?.status)) && <div className="check_box_react_gst_progress_block" >
                                  <p> GSTIN: </p>                            
                                  <span>{progressStep?.validationResult?.GSTIN?.status}</span>
                              </div>}

                              {/* <div className="check_box_react_gst_progress_block" >
                                  <p> MSME </p>      
                              </div> */}
                              {(!isEmptyDash(progressStep?.validationResult?.MSME_NO?.status)) && <div className="check_box_react_gst_progress_block" >
                                  <p> MSME Status: </p>                            
                                  <span>{progressStep?.validationResult?.MSME_NO?.status}</span>
                              </div>}
                              {(!isEmptyDash(progressStep?.validationResult?.MSME_NO?.enterpriseType)) && <div className="check_box_react_gst_progress_block" >
                                  <p> Type of Enterprise: </p>                            
                                  <span>{progressStep?.validationResult?.MSME_NO?.enterpriseType}</span>
                              </div>}

                              {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.status)) && <div className="check_box_react_gst_progress_block" >
                                  <p> PAN Status: </p>                            
                                  <span>{progressStep?.validationResult?.PAN_NO?.status}</span>
                              </div>}                                    

                              {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.operativeStatus)) && <div className="check_box_react_gst_progress_block" >
                                  <p> Operative Status: </p>                            
                                  <span>{progressStep?.validationResult?.PAN_NO?.operativeStatus}</span>
                              </div>}

                              {(!isEmptyDash(progressStep?.validationResult?.PAN_NO?.specifiedPerson)) && <div className="check_box_react_gst_progress_block" >
                                  <p> Specified Person: </p>                            
                                  <span>{progressStep?.validationResult?.PAN_NO?.specifiedPerson}</span>
                              </div>}
                            {/* {Object.entries(gstValidation).map(([key, value], i) => (
                              <div className="check_box_react_gst_progress_block" key={i}>
                                <p>{key}</p>
                                {value ? (
                                  <DoneIcon className="icon_react_check_body" />
                                ) : (
                                  <HighlightOffIcon className="icon_react_check_body" />
                                )}
                              </div>
                            ))} */}

                          </div>
                        )}
                      </>

                      {/* {validationResultArr.map((ele, i) => (
                            <>
                              <div className="check_box_react_gst_progress_block">
                                <p>{ele?.name}</p>
                                {ele?.isValid == true && (
                                  <CheckCircleIcon className="icon_react_check_body" />
                                )}
                                {ele?.isValid == false && (
                                  <HighlightOffIcon className="icon_react_check_body" />
                                )}
                              </div>
                            </>
                          ))} */}

                      {/* <div className="check_box_react_gst_progress_block">
                        <p>GST</p>
                        <CheckCircleIcon className="icon_react_check_body" />
                      </div>
                      <div className="check_box_react_gst_progress_block">
                        <p>PAN</p>
                        <HighlightOffIcon className="icon_react_check_body" />
                      </div>
                      <div className="check_box_react_gst_progress_block">
                        <p>MSME</p>
                        <CheckCircleIcon className="icon_react_check_body" />
                      </div> */}

                    </div>
                  )}
              </Step>
            ))}
          </Stepper>
          {/* <Link className="link_view_vendor" to="/admin/onboarding-from">
            <Button className="view_submit_Details">View Details</Button>
          </Link> */}
          <div className="div-details-center">
            <button className="" onClick={viewDetails}>
              View Details
            </button>
            {progressStep?.finalStatus === "SAP Creation Failed" && (
              isReinitiateDisabled ? (
                <button onClick={discardReInitateProcess} style={{ marginLeft: '10px', padding: '10px' }}>
                  <Tooltip title="Discard SAP Vendor Creation" placement="top-start" arrow>
                    Discard
                  </Tooltip>
                </button>
              ) : (
                <button onClick={reInitateProcess} style={{ marginLeft: '10px', padding: '10px' }}>
                  <Tooltip title="Re-Initiate SAP Vendor Creation" placement="top-start" arrow>
                    Re-initiate
                  </Tooltip>
                </button>
              )
            )}
          </div>



          {!isEmptyDash(progressStep?.lastStepData) && (
            <div>
              {progressStep?.finalStatus == "Started" && (
                <>
                  {progressStep?.lastStepData?.sections.map((ele, i) => (
                    <>
                      <div>
                        <p className="react_tax_step_three_taxation">
                          {/* {i == 0 && "Taxation"}
                          {i == 1 && "Accounts"}
                          {i == 2 && "Buyer"} */}
                          {progressStep?.lastStepData?.stepName}
                        </p>

                        <div className="react_step_six_onboarding_open_blocklist">
                          {ele?.fields?.map((fieldData, j) => (
                            <>
                              <div>
                                <div>
                                  <p className="lets_react_onboarding_step_three_body">
                                    {fieldData?.name}
                                    {fieldData?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </p>

                                  {fieldData?.type == "Dropdown" && (
                                    <>
                                      <select
                                        class="form-select seclected_form_detail1s"
                                        aria-label="Default select example"
                                        fdprocessedid="zlera"
                                        onChange={(e) =>
                                          onSelectChange(
                                            e,
                                            ele,
                                            i,
                                            fieldData,
                                            j
                                          )
                                        }
                                        value={fieldData?.response?.optionId}
                                        disabled={!fieldData?.editAccess}
                                      >
                                        <option value={""} disabled selected>
                                          Please Select
                                        </option>
                                        {fieldData?.options.map(
                                          (optionEle, k) => (
                                            <>
                                              <option value={optionEle?._id}>
                                                {optionEle?.optionName}
                                              </option>
                                            </>
                                          )
                                        )}
                                      </select>
                                    </>
                                  )}

                                  {fieldData?.type == "MultiSelect" && (
                                    <>
                                      <FormControl className="seclected_form_detail1ses">
                                        <Select
                                          class="form-select seclected_form_detail1ses"
                                          labelId="demo-multiple-checkbox-label"
                                          id="demo-multiple-checkbox"
                                          multiple
                                          value={
                                            isEmptyDash(
                                              fieldData?.response?.optionIds
                                            )
                                              ? []
                                              : fieldData?.response?.optionIds
                                          }
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              ele,
                                              i,
                                              fieldData,
                                              j
                                            )
                                          }
                                          placeholder="Please Select"
                                          // input={<OutlinedInput label="Tag" />}
                                          renderValue={(selected) =>
                                            selected.join(", ")
                                          }
                                          MenuProps={MenuProps}
                                          disabled={!fieldData?.editAccess}
                                        >
                                          {fieldData?.options.map(
                                            (multiSelectData) => (
                                              <MenuItem
                                                key={multiSelectData?._id}
                                                value={multiSelectData?._id}
                                              >
                                                <Checkbox
                                                  checked={
                                                    isEmptyDash(
                                                      fieldData?.response
                                                        ?.optionIds
                                                    )
                                                      ? false
                                                      : fieldData?.response?.optionIds.indexOf(
                                                        multiSelectData?._id
                                                      ) > -1
                                                  }
                                                />
                                                <ListItemText
                                                  primary={
                                                    multiSelectData?.optionName
                                                  }
                                                />
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                      {/* <select
                                class="form-select seclected_form_detail1s"
                                aria-label="Default select example"
                                fdprocessedid="zlera"
                                onChange={(e) => onSelectChange(e, ele, i, fieldData, j)}
                                value={fieldData?.response?.optionId}
                                disabled={!fieldData?.editAccess}
                              >
                                <option value={""} disabled selected>
                                  Please Select
                                </option>
                                {fieldData?.options.map(
                                  (optionEle, k) => (
                                    <>
                                      <option value={optionEle?._id}>
                                        {optionEle?.optionName}
                                      </option>
                                    </>
                                  )
                                )}
                              </select> */}
                                    </>
                                  )}

                                  {fieldData?.type == "String" && (
                                    <>
                                      <input
                                        class="form-control vendor_maine_package"
                                        type="text"
                                        value=""
                                        fdprocessedid="cynpkh"
                                        placeholder="IN"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  ))}

                  {progressStep?.allStepsCompleted == false && (
                    <div className="lets_react_progress_btn_vendorlist">
                      <button
                        type="button"
                        class="btn clear_btnse"
                        fdprocessedid="mvc61"
                        onClick={onClearForm}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        class="btn btn-success save_next_btnse"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  )}

                </>
              )}



              {progressStep?.allStepsCompleted == true && isReinitiateDisabled === true && (
                <>
                  {progressStep?.lastStepData?.sections.map((ele, i) => (
                    <>
                      <div>
                        <p className="react_tax_step_three_taxation">
                          {progressStep?.lastStepData?.stepName}
                        </p>

                        <div className="react_step_six_onboarding_open_blocklist">
                          {ele?.fields?.map((fieldData, j) => (
                            <>
                              <div>
                                <div>
                                  <p className="lets_react_onboarding_step_three_body">
                                    {fieldData?.name}
                                    {fieldData?.required && (
                                      <span className="required">*</span>
                                    )}
                                  </p>

                                  {fieldData?.type == "Dropdown" && (
                                    <>
                                      <select
                                        class="form-select seclected_form_detail1s"
                                        aria-label="Default select example"
                                        fdprocessedid="zlera"
                                        onChange={(e) =>
                                          onSelectChange(
                                            e,
                                            ele,
                                            i,
                                            fieldData,
                                            j
                                          )
                                        }
                                        value={fieldData?.response?.optionId}
                                        disabled={isSubmitButtonDisabled === true}
                                      >
                                        <option value={""} disabled selected>
                                          Please Select
                                        </option>
                                        {fieldData?.options.map(
                                          (optionEle, k) => (
                                            <>
                                              <option value={optionEle?._id}>
                                                {optionEle?.optionName}
                                              </option>
                                            </>
                                          )
                                        )}
                                      </select>
                                    </>
                                  )}

                                  {fieldData?.type == "MultiSelect" && (
                                    <>
                                      <FormControl className="seclected_form_detail1ses">
                                        <Select
                                          class="form-select seclected_form_detail1ses"
                                          labelId="demo-multiple-checkbox-label"
                                          id="demo-multiple-checkbox"
                                          multiple
                                          value={
                                            isEmptyDash(
                                              fieldData?.response?.optionIds
                                            )
                                              ? []
                                              : fieldData?.response?.optionIds
                                          }
                                          onChange={(e) =>
                                            handleChange(
                                              e,
                                              ele,
                                              i,
                                              fieldData,
                                              j
                                            )
                                          }
                                          placeholder="Please Select"
                                          renderValue={(selected) =>
                                            selected.join(", ")
                                          }
                                          MenuProps={MenuProps}
                                          disabled={isSubmitButtonDisabled === true}
                                        >
                                          {fieldData?.options.map(
                                            (multiSelectData) => (
                                              <MenuItem
                                                key={multiSelectData?._id}
                                                value={multiSelectData?._id}
                                              >
                                                <Checkbox
                                                  checked={
                                                    isEmptyDash(
                                                      fieldData?.response
                                                        ?.optionIds
                                                    )
                                                      ? false
                                                      : fieldData?.response?.optionIds.indexOf(
                                                        multiSelectData?._id
                                                      ) > -1
                                                  }
                                                />
                                                <ListItemText
                                                  primary={
                                                    multiSelectData?.optionName
                                                  }
                                                />
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </>
                                  )}

                                  {fieldData?.type == "String" && (
                                    <>
                                      <input
                                        class="form-control vendor_maine_package"
                                        type="text"
                                        value=""
                                        fdprocessedid="cynpkh"
                                        placeholder="IN"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  ))}

                  {progressStep?.allStepsCompleted == true && isReinitiateDisabled === true && isSubmitButtonDisabled === false && (
                    <div className="lets_react_progress_btn_vendorlist">
                      <button
                        type="button"
                        class="btn clear_btnse"
                        fdprocessedid="mvc61"
                        onClick={onClearForm}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        class="btn btn-success save_next_btnse"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  )}

                </>
              )}
              
              {((progressStep?.finalStatus == "SAP Creation Failed" && isSapVendorCreation === true && isReinitiateDisabled === true) && props?.assigedId == UserObj?._id) && (
                <div className="lets_onboardingprogress_detail_business">
                  {progressStep?.allStepsCompleted == true && (
                    <>
                      <p className="creation_sap_reactdetail">
                        Approve for SAP Vendor Creation
                      </p>
                      <div class="package_listing_block_body">
                        <label className="remark_listing_block_body_react">
                          Remark
                        </label>
                        <textarea
                          class="form-control "
                          onChange={(e) => {
                            setTextAreaVal(e.target.value);
                          }}
                          rows={2}
                        />
                      </div>

                      <div className="btn_hold_initiate_react_onboarding_progre1">
                        <button
                          className="btn_initiate_reactsr button-approve"
                          onClick={() => onSAPCreateClick("Approved")}
                        >
                          Approve{" "}
                        </button>
                        <button
                          className="btn_hold_reactsr button-reject"
                          onClick={() => onSAPCreateClick("Rejected")}
                        >
                          Reject{" "}
                        </button>
                        <button
                          className="btn_hold_reactsr button-hold"
                          onClick={() => onSAPCreateClick("Hold")}
                        >
                          Hold{" "}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}



              {((progressStep?.finalStatus == "Started" ||
                progressStep?.finalStatus == "Hold")  && props?.assigedId == UserObj?._id) && (
                  <div className="lets_onboardingprogress_detail_business">
                    {progressStep?.allStepsCompleted == true && (
                      <>
                        <p className="creation_sap_reactdetail">
                          Approve for SAP Vendor Creation
                        </p>
                        <div class="package_listing_block_body">
                          <label className="remark_listing_block_body_react">
                            Remark
                          </label>
                          <textarea
                            class="form-control "
                            onChange={(e) => {
                              setTextAreaVal(e.target.value);
                            }}
                            rows={2}
                          />
                        </div>

                        <div className="btn_hold_initiate_react_onboarding_progre1">
                          <button
                            className="btn_initiate_reactsr button-approve"
                            onClick={() => onSAPCreateClick("Approved")}
                          >
                            Approve{" "}
                          </button>
                          <button
                            className="btn_hold_reactsr button-reject"
                            onClick={() => onSAPCreateClick("Rejected")}
                          >
                            Reject{" "}
                          </button>
                          <button
                            className="btn_hold_reactsr button-hold"
                            onClick={() => onSAPCreateClick("Hold")}
                          >
                            Hold{" "}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
            </div>
          )}
        </Box>
      </div>

      <ConfirmModal
        isConfirmModalOpen={isConfirmModalOpen}
        closeConfirmModal={closeConfirmModal}
        successConfirmModal={successConfirmModal}
        modalMsg={confirmModalText}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default OnboardingProgress;
